export default import.meta.ROLLDOWN_FILE_URL_$aJKcPoFoBY6iMm7b0KspA